/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMetricAvailabilitySchema } from "./metricAvailabilitySchema.ts";
import { goodLuckCoreDTOsMetricComparisonScopeSchema } from "./metricComparisonScopeSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayMetricValueDtoSchema = z.object({
  key: z.string().nullish(),
  value: z.number().nullish(),
  get availability() {
    return goodLuckCoreDTOsMetricAvailabilitySchema.optional();
  },
  percentile: z.number().nullish(),
  peerCount: z.optional(z.int()),
  peerGroupRole: z.string().nullish(),
  get comparisonScope() {
    return goodLuckCoreDTOsMetricComparisonScopeSchema.optional();
  },
  gamesCounted: z.optional(z.int()),
});
